import React, {FC} from 'react';
import { ContentPanelContainer } from './content-panel-contaner';
import { ContentHeader } from './content-header';
import { ContentPanel } from './content-panel';

export const Contact:FC = () => {

    return (
        <ContentPanelContainer>
            <ContentHeader headerText="contact"/>
            <ContentPanel>
                Please feel free to contact me 
                at <a href="mailto:mroche74@gmail.com">mroche74@gmail.com
                </a>.
            </ContentPanel>          
        </ContentPanelContainer>
    )
}